import React from "react";

export default function Input({ name, label, placeholder, pattern }) {
  return (
    <div className="input-main">
      <label htmlFor={name}>{label}:</label>
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        // pattern={pattern}
        required
      />
    </div>
  );
}
